import * as React from 'react';
import Base, { Props as BaseProps } from '../Base/Base';
import './ProgressSpinner.css';

const radius = 8;
const radiusPi = (radius * 2) * Math.PI;
const viewBox = 24;
const viewBoxC = viewBox / 2;

export interface Props extends BaseProps {
  /** Side of the indicator */
  size?: string;
}

/**
 * A simple indeterminate progress spinner.
 */
const ProgressSpinner: React.FunctionComponent<Props> = (props: Props) => {
  const {
    size,
    ...rest
  } = props;

  return (
    <Base { ...rest }
        Component="svg"
        className="ProgressSpinner"
        height={ size }
        viewBox={ `0 0 ${viewBox} ${viewBox}` }
        width={ size }>
      <circle
          cx={ viewBoxC }
          cy={ viewBoxC }
          fill="transparent"
          r={ radius }
          stroke="currentColor"
          strokeDasharray={ radiusPi }
          strokeWidth="2px"
          transform={ `rotate(-90 ${viewBoxC} ${viewBoxC})` }>
        <animate
            attributeName="stroke-dashoffset"
            calcMode="spline"
            dur="2000ms"
            fill="freeze"
            keySplines="0.4 0 0.2 1"
            repeatCount="indefinite"
            values={ `${radiusPi * 3};${radiusPi}` }></animate>

        <animateTransform
            attributeName="transform"
            calcMode="spline"
            dur="2000ms"
            fill="freeze"
            keySplines="0.4 0 0.2 1"
            repeatCount="indefinite"
            type="rotate"
            values={ `-90 ${viewBoxC} ${viewBoxC};270 ${viewBoxC} ${viewBoxC}` }></animateTransform>
      </circle>
    </Base>
  );
};

ProgressSpinner.defaultProps = {
  size: '1.5rem',
};

export default ProgressSpinner;
